module.exports = __webpack_public_path__ + "img/w-r.4808dbc5.png";